import React from 'react';
import { Button } from '@/components/display/button';
import { NoMediaPlansIcon } from '@/icons/no-media-plans-icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHand, faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { PlatformBuysSearchModal } from '@/features/media-plans/media-plans-search';
import { useExecutionContext } from '@/features/executions/execution-context';
import { useParams } from 'react-router-dom';
import { NoMediaPlatformsImage } from '@/features/media-buys/no-media-platforms-image';
import { AiCreateMediaPlanButton } from '@/features/ai/media-plans/ai-create-media-plan-button';
import { useFlagEnabled } from '@/utils/feature-flags';

export function NoMediaPlansPage() {
  const [open, setOpen] = React.useState(false);
  const assistMeEnabled = useFlagEnabled('assist-me');
  const { lineItemId } = useParams();
  const { lineItems } = useExecutionContext();
  const lineItem = lineItems.find(lineItem => lineItem.id === lineItemId);

  if (!lineItem) return null;

  if (lineItem.media_platforms.length === 0) {
    return <NoMediaPlatformsView />;
  }

  return (
    <div className="w-full h-full flex flex-col items-center text-gray-600">
      <div className="w-[400px] mt-8">
        <NoMediaPlansIcon />
      </div>
      <div className="text-2xl font-bold mt-8">No Media Plans yet</div>
      <div className="text-lg font-light mt-4">
        Search and add your Platform Buys to create Media Plans
      </div>
      <div className="mt-4">
        Search for Platform Buys you've already created on the DSP. Add them all at once. Then
        define their Media Plan
      </div>
      <div className="mt-4 flex items-center gap-2">
        {assistMeEnabled ? (
          <AiCreateMediaPlanButton
            executionLineItemId={lineItem.id}
            strategyId={lineItem.strategy_id}
            lineItemName={lineItem.name}
            lineItemPlannedUnitCost={lineItem.planned_unit_cost}
            lineItemUnitPriceTypeName={lineItem.unit_price_type_name}
            lineItemGeo={lineItem.geo}
            lineItemTacticName={lineItem.tactic_name}
            lineItemChannelName={lineItem.channel_name}
            mediaPlatforms={lineItem.media_platforms}
            size="default"
          />
        ) : null}
        <Button className="cursor-pointer" onClick={() => setOpen(true)}>
          Create Media Plans
        </Button>
      </div>
      <div className="flex rounded-sm bg-gray-200 mt-4">
        <div className="flex items-center px-1">
          <FontAwesomeIcon icon={faInfoCircle} />
        </div>
        <div className="rounded bg-gray-100 px-2 py-1 text-sm text-gray-800">
          Newly created Platform Buys are available in Bravo the following morning
        </div>
      </div>
      <div className="flex-2" />
      <PlatformBuysSearchModal lineItem={lineItem} open={open} setOpen={setOpen} />
    </div>
  );
}

function NoMediaPlatformsView() {
  return (
    <div className="flex h-full items-center justify-around">
      <div className="flex flex-col items-center gap-4">
        <NoMediaPlatformsImage />
        <div className="flex flex-col items-center gap-2 text-gray-600">
          <div className="flex flex-col items-center text-lg font-semibold">
            No Platforms have been assigned for this line item
          </div>
          <div className="text-center text-sm">
            Platform must be assigned to a line item before Media Plans can be created. <br />
            Reach out to your Sr. Media Trader to get platforms assigned.
          </div>
        </div>
        <div className="flex rounded-sm bg-red-100">
          <div className="flex items-center px-1 text-red-600">
            <FontAwesomeIcon icon={faHand} />
          </div>
          <div className="rounded bg-red-200 px-2 py-1 text-sm text-gray-800">
            No Platform assigned
          </div>
        </div>
      </div>
    </div>
  );
}
